export const Debug = {
  boot_up: "action_Start_When_Boot_Up",
  enable_wanlan: "action_Enable_LANWAN_Packet_Capture",
  start_capture: "action_Start_Capture",
  save_log: "Save_Debug_File",
};

export default Debug;
